// extracted by mini-css-extract-plugin
export var card = "_jc-5";
export var cardSelected = "_jc-4";
export var image = "_jc-3";
export var modal = "_jc-0";
export var modalContent = "_jc-1";
export var table = "_jc-2";